export class FullCalendarEvent {
    constructor() {
        this.id = '';
        this.title = '';
        this.start = '';
        this.end = '';
        this.allDay = false;
        this.url = '';
    }
    copyFromReservation(reservation) {
        this.id = String(reservation.id);
        this.title = reservation.name;
        this.start = reservation.startTime;
        this.end = reservation.endTime;
        this.allDay = false;
        this.url = reservation.redirectUrl;
    }
}
